import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import ShowFileImageView from '../../../components/views/mx/creditoReal/ShowFileImageView';
import {State} from '../../../types/mx/reducers';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {};
};

const ShowFileImageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShowFileImageView);

export default ShowFileImageContainer;